export default {
  namespaced: true,

  state: {
    //layerList: [ 1, 2, 3 ],
    layerList: [ {name: "1", value: 1},
      {name: "2", value: 2},
      {name: "3", value: 3},
      {name: "единичные деревья", value: 11}
    ],
    genList: [ 1, 2, 3 ]
  }
};